import MyProfilesTable from './MyProfilesTable';

export default function MyProfilesSettings() {
  return <MyProfilesTable />;
}
